import { render, staticRenderFns } from "./RiskScenarioPanel.vue?vue&type=template&id=12e1f231&"
import script from "./RiskScenarioPanel.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports